<div class="p-4">
    <nz-skeleton
      [ngClass]="loading ? 'p-3' : 'p-0'"
      [nzLoading]="loading"
      [nzActive]="true"
    >
    <div class="d-flex flex-column flex-md-row pb-0 justify-content-between align-items-lg-center align-items-start">
      <span class="text-black title">Analytics & Performance Delivery</span>
      <div>
        <app-date-month-picker [isShowSelection]="false" (change)="changeMonthPicker($event)"></app-date-month-picker>
      </div>
    </div>
    <hr>
    <div class="mt-3">
      <div
        id="chart"
        #chartContainer
        *ngIf="
          chartOptions.series &&
          chartOptions.chart &&
          chartOptions.xaxis &&
          chartOptions.stroke &&
          chartOptions.tooltip &&
          chartOptions.yaxis
        "
      >
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.yaxis"
          [legend]="legend"
          [stroke]="chartOptions.stroke"
          [tooltip]="chartOptions.tooltip"
          [markers]="chartOptions.markers || {}"
          [dataLabels]="chartOptions.dataLabels || { enabled: false }"
        ></apx-chart>
      </div>
    </div>
    </nz-skeleton>
</div>
